<template>
    <teleport to="#modal">
        <Loading
            :visible="loading"
        >
        </Loading>
    </teleport>
    <div class="m-auto px-8 md:px-20 pt-4">
        <Alert v-if="!hasNinjaId" class="bg-next-orange mb-3">Non puoi creare una richiesta di supporto perché il tuo utente non è
            presente su ninja
        </Alert>
        <div v-show="state == 0" class="max-w-screen-2xl m-auto ">
            <h1 class="font-bold text-2xl pb-5">Richiedi supporto</h1>
            <div class="mb-3">
                <Field v-model="subject" field_name="Titolo" placeholder="Titolo"
                       :errors="getErrors('titolo')"></Field>
            </div>
            <div class="mb-3">
                <Field field_name="Messaggio" :errors="getErrors('messaggio')">
                    <editor
                        v-model="content"
                        api-key="no-api-key"
                        :init="{
                 height: 300,
                 width: '100%',
                 menubar: false,
                 content_css: '/css/tinymce.css',
                 plugins: [
                   'advlist autolink lists link charmap print preview anchor codesample',
                   'searchreplace visualblocks code fullscreen',
                   'insertdatetime media table paste code help wordcount'
                 ],
                 toolbar:
                   'undo redo | h1 h2 | bold italic codesample | \
                   alignleft aligncenter alignright alignjustify | \
                   bullist numlist | removeformat'
               }"
                    />
                </Field>
            </div>


            <div class="flex justify-end pt-3">
                <NextButton variant="primary" @click="sendSupport"
                            class="w-48 text-sm sm:block py-2 px-4 ml-3">Invia
                </NextButton>
            </div>
        </div>
        <div v-show="state == 1" class="pt-5 text-center">
            Grazie! La tua richiesta è stata inviata correttamente
            <div class="flex justify-center pt-3">
                <NextButton variant="outline-secondary" component="router-link" :to="{name:'Home'}"
                            class="sm:block py-1 px-3">
                    Torna alla home
                </NextButton>
            </div>
        </div>

        <div v-show="state == 2" class="pt-5">
            <Alert>Qualcosa è andato storto, riprova più tardi o contatta l'assistenza.</Alert>
            <div class="flex justify-center pt-3 text-center">
                <NextButton variant="outline-secondary" component="router-link" :to="{name:'Home'}"
                            class="sm:block py-1 px-3">
                    Torna alla home
                </NextButton>
            </div>
        </div>
    </div>

</template>

<script lang="ts">
import {Options, Vue} from 'vue-class-component';
import NextButton from "@/components/NextButton.vue";
import supportManager from "../api/Support";
import Field from "@/components/Field.vue";
import Editor from '@tinymce/tinymce-vue'
import Loading from "@/components/Loading.vue";
import Alert from "@/components/Alert.vue";
import {mapGetters} from "vuex";

@Options({
    name: 'Support',
    components: {
        Alert,
        Loading,
        Field,
        Editor,
        NextButton,
    },
    computed: {
        ...mapGetters([
            'me',
            'hasNinjaId',
        ])
    },
    methods: {}
})
export default class Support extends Vue {

    content = ''
    subject = ''
    errors = {}
    state = 0
    loading = false

    getErrors(field: string) {
        return (this.errors as any)[field]
    }

    sendSupport() {
        this.loading = true
        return supportManager.creaSupporto({messaggio: this.content, titolo: this.subject}).then((res) => {
            this.state = 1
        }).catch((res) => {
            if (res.response.status == 422) {
                this.errors = res.response.data.errors
            } else {
                this.state = 2
            }
        }).finally(() => {
            this.loading = false
        })
    }

}
</script>


<style lang="scss">

</style>
